import { render, staticRenderFns } from "./SimpleDataTable.vue?vue&type=template&id=f1f69bea&scoped=true&"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js&"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f69bea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
})
